// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".makes-hp{font-family:var(--font-regular);margin-bottom:60px;width:1200px;max-width:100%}@media(max-width:1024px){.makes-hp{width:100%!important}}.makes-hp h2{text-align:center;margin-bottom:60px;margin-top:60px;font-weight:var(--font-weight-extra-bold);font-size:var(--text-7xl)}.makes-hp a{font-family:var(--font-regular);text-decoration:none;line-height:2.2;font-size:var(--text-lg)}", ""]);
// Exports
module.exports = exports;
